import { useGetAiSlidesQuery } from "@api/slides-library";
import { useGetLayoutsQuery } from "@api/static-assets";
import { useAppSelector } from "@store";
import { getSelectedSetting } from "@store/story/selectors";
import { useMemo } from "react";
import { useSlidesLibraryStoreShallow } from "../../../shared/store";
import {
  type RawLayoutsExport,
  transformLayoutsExport,
} from "../data/layouts-source";

export const useGetAiSlides = () => {
  const { type } = useSlidesLibraryStoreShallow((s) => ({
    type: s.type,
  }));

  const category = useAppSelector(
    (state) =>
      getSelectedSetting<Record<string, unknown>>("wizard")(state)?.[
        "wizard doc category"
      ] || "",
  ) as string;

  const isLayoutType = type === "layouts";
  const isTemplateType = type === "templates";

  // Templates still come from the backend; layouts are fetched from the static
  // assets CDN (cached by RTK Query) and transformed into the grid shape below.
  const { data, isLoading, isError, isFetching } = useGetAiSlidesQuery(
    {
      type: isTemplateType ? "Basic" : "Layout",
      category: isTemplateType ? category : "",
    },
    { skip: !isTemplateType },
  );

  const {
    data: rawLayouts,
    isLoading: isLayoutsLoading,
    isError: isLayoutsError,
  } = useGetLayoutsQuery(undefined, { skip: !isLayoutType });

  const layouts = useMemo(
    () =>
      rawLayouts
        ? transformLayoutsExport(rawLayouts as RawLayoutsExport)
        : undefined,
    [rawLayouts],
  );

  if (isLayoutType) {
    return {
      data: layouts,
      isLoading: isLayoutsLoading,
      isError: isLayoutsError,
    };
  }

  return { data, isLoading: isLoading || isFetching, isError };
};
